import { render, staticRenderFns } from "./CustomerEditTabInformation.vue?vue&type=template&id=270322fa&"
import script from "./CustomerEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./CustomerEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./CustomerEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports